import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, XHRBackend } from '@angular/http';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { HttpClientModule } from '@angular/common/http';

/*
 * Platform and Environment providers/directives/pipes
 */
import { AuthenticateXHRBackend } from './authenticate-xhr.backend';
import { environment } from 'environments/environment';
import { ROUTES } from './app.routes';
import { CheckAllService } from './layout/utils/directives/check-all.service';
// App is our top level component
import { App } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';
import { ErrorComponent } from './error/error.component';

import { ConfigService } from './shared/services/config.service';
import { AuthGuard } from 'app/auth.guard';
import { UserService } from 'app/shared/services/user.service';
import { DataService, BarraConfiguraciones } from 'app/visualis/services/visualis.data.service';
import { VisualisLanguageService } from './visualis/services/language.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ColorPickerModule } from 'ngx-color-picker';
import { ResizeService } from 'app/visualis/services/resize.element.service';
import { AppReadyEvent } from './shared/models/appreadyevent';
import { ModalModule, BsDropdownModule } from 'ngx-bootstrap';
import { LogService } from './visualis/services/log.service';

// Application wide providers
const APP_PROVIDERS = [
  APP_RESOLVER_PROVIDERS,
  AppState,
  CheckAllService
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ App ],
  declarations: [
    App,
    ErrorComponent,
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ColorPickerModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    HttpClientModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '20px',
      primaryColour: '#ffffff',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff'
  }),
    ReactiveFormsModule,
    HttpModule,
    SimpleNotificationsModule.forRoot(),
    RouterModule.forRoot(ROUTES, {
      useHash: true,
      preloadingStrategy: PreloadAllModules
    })
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [ConfigService, AuthGuard, UserService, DataService, VisualisLanguageService, ResizeService, AppReadyEvent, BarraConfiguraciones, LogService,
    {
      provide: XHRBackend,
      useClass: AuthenticateXHRBackend
    },
    environment.ENV_PROVIDERS,
    APP_PROVIDERS
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts